// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.editUser_dashboard__yUISc {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.editUser_dashboardContain__GtVNk {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.editUser_bodythemedark__gJc0k .editUser_dashboardContain__GtVNk,
.editUser_bodythemedark__gJc0k .editUser_dashboard__yUISc,
.editUser_bodythemedark__gJc0k .editUser_cont2__WDGNX {
  background-Color: #0f1824;
}

.editUser_top_header__7A80O .editUser_top_header_inner__2GMP0 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.editUser_cont2__WDGNX {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.editUser_subLink__20r54 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.editUser_footer__arSK6 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.editUser_bodythemelight__KB6by {
  background-color: #fff;
  padding-top: 90px;
}

.editUser_bodythemedark__gJc0k {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.editUser_headerthemelight__RcR6X {
  background-color: #fff;
}

.editUser_headerthemedark__1XW9I {
  background-color: #132337;
}

.editUser_top_header__7A80O {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.editUser_menuthemelight__93STk {
  background-color: #fff;
}

.editUser_menuthemedark__yR0K2 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.editUser_menulinklight__T1Ugp span {
  color: #666666 !important;
}

.editUser_menulinklight__T1Ugp a {
  color: #CBCBCB !important;
}

.editUser_menulinklight__T1Ugp:hover span, .editUser_menulinklight__T1Ugp:hover a {
  color: #fff !important;
}

.editUser_menulinkdarkSelected__bZWxL {
  background-color: #1c2e45;
  color: #fff;
}

.editUser_menuthemelight__93STk .editUser_menulinklightSelected__LxANp {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.editUser_menulinkdark__4Mzbh {
  color: #60677e !important;
}

.editUser_menulinklight__T1Ugp:hover {
  color: #fff !important;
  background-color: #205440;
}

.editUser_menulinkdark__4Mzbh:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.editUser_headinglight__iYkug {
  color: #60677e;
}

.editUser_headingdark__CC5Nk {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.editUser_searchboxlight__JtJHv {
  background-color: #fff;
  border: none;
}

.editUser_searchboxdark__c8WH1 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.editUser_searchboxdark__c8WH1::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.editUser_tableheadlight__t32QY {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.editUser_tableheadlight__t32QY th {
  color: #fff;
}

thead .editUser_tableheadlight__t32QY th:first-child,
thead .editUser_tableheaddark__IU1BY th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .editUser_tableheadlight__t32QY th:last-child,
thead .editUser_tableheaddark__IU1BY th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.editUser_table__UBG50.editUser_table-borderless__vgOBj {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.editUser_tableheaddark__IU1BY {
  background-color: #1e1e2d;
  color: #fff;
}

.editUser_table-borderless__vgOBj tr:nth-child(even) {
  background-color: #F9FAFB;
}

.editUser_table-borderless__vgOBj .editUser_left-section__5Ygpr {
  padding-top: 10px;
}

.editUser_tablebodylight__xGR7k td,
.editUser_tablebodydark__ANb75 td {
  padding: 1rem 1rem !important;
}

.editUser_tablebodylight__xGR7k {
  background-color: #fff;
}
.editUser_tablebodylight__xGR7k:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.editUser_tablebodydark__ANb75 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.editUser_tablebodydark__ANb75:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.editUser_paginationlight__UynJG {
  color: #60677e !important;
  font-size: 13px !important;
}

.editUser_paginationdark__EfSxZ {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.editUser_formthemelight__\\+6R3K {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.editUser_formthemedark__91io7 {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.editUser_formthemedark__91io7 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.editUser_viewformlight__y32\\+k {
  background-color: #f3f6f9;
}

.editUser_permissionboxlight__uvNqc {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.editUser_permissionboxdark__bgl1b {
  background-color: #151521;
  border: solid 1px #242434;
}

.editUser_errormsgclr__vFQxR {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.editUser_graphclrlight__0tGaV {
  background-color: #fff;
}

.editUser_graphclrdark__Oe4fN {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#editUser_card1bglight__kUxQl {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#editUser_card1bglight__kUxQl:hover {
  background: #f7fffc;
}

#editUser_card1bgdark__tfYHD {
  background: #392f28;
}

#editUser_card1bgdark__tfYHD:hover {
  background: #f7fffc;
}

#editUser_card2bglight__ZXiVd {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#editUser_card2bglight__ZXiVd:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#editUser_card2bgdark__O1gIJ {
  background: #1c3238;
}

#editUser_card3bglight__xkw1U {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#editUser_card3bglight__xkw1U:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#editUser_card3bgdark__FCvDO {
  background: #3a2434;
}

#editUser_card4bglight__pic05 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#editUser_card4bglight__pic05:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#editUser_card4bgdark__oir3Z {
  background: #2f264f;
}

#editUser_card1bgdark__tfYHD a, #editUser_card1bgdark__tfYHD p,
#editUser_card2bgdark__O1gIJ a, #editUser_card2bgdark__O1gIJ p,
#editUser_card3bgdark__FCvDO a, #editUser_card3bgdark__FCvDO p,
#editUser_card4bgdark__oir3Z a, #editUser_card4bgdark__oir3Z p {
  color: #fff;
}

/* 
Action button theme
*/
.editUser_actionbtnlight__3hMAT {
  color: rgba(70, 71, 91, 0.8705882353);
}

.editUser_actionbtndark__c1n4B {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.editUser_profiledropdownlight__zqmBO {
  background-color: #fff;
}

.editUser_profiledropdowndark__WK9BI {
  background-color: #151521;
}

.editUser_settingsection__qkXU0 #editUser_addform__ovjfH.editUser_formthemedark__91io7 .editUser_savebtn__RGuGY {
  background-color: #0a2574;
  color: #fff;
}

#editUser_addform__ovjfH.editUser_formthemedark__91io7 .editUser_savebtn__RGuGY {
  background-color: #0a2574;
  color: #fff;
}

.editUser_profile_conatiner__4m7UK {
  border-radius: 5px !important;
}

.editUser_bodythemedark__gJc0k .editUser_ag-theme-alpine__hlul9 .editUser_ag-row__uJXdt {
  background: #000 !important;
}

.editUser_bodythemedark__gJc0k .editUser_formbtn__xQSoi {
  background-color: #0a2574;
}

.editUser_bodythemedark__gJc0k .editUser_resetbtn__-wDgG {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.editUser_bodythemedark__gJc0k .editUser_resetbtn__-wDgG:hover {
  background-color: #0a2574;
}

.editUser_headingdark__CC5Nk span {
  background-color: #132337;
}

.editUser_resetbtn__-wDgG {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.editUser_resetbtn__-wDgG:hover,
.editUser_resetbtn__-wDgG:active,
.editUser_resetbtn__-wDgG:focus {
  background-color: #205440;
  color: #fff;
}

.editUser_addBtn__UcTNJ {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.editUser_addBtn__UcTNJ svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.editUser_addBtn__UcTNJ:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.editUser_cust_addBtn__ZO2er.editUser_addBtn__UcTNJ svg {
  top: 2px;
}

.editUser_deleteBtn__BmqwH {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.editUser_deleteBtn__BmqwH {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.editUser_deleteBtn__BmqwH:active, .editUser_deleteBtn__BmqwH:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.editUser_deleteBtn__BmqwH svg {
  position: relative;
  top: -2px;
}

.editUser_deleteBtn__BmqwH:hover,
.editUser_deleteBtn__BmqwH:active,
.editUser_deleteBtn__BmqwH:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.editUser_confirmBtn__j\\+4hp {
  background-color: #205440;
}

.editUser_confirmBtn__j\\+4hp:hover,
.editUser_confirmBtn__j\\+4hp:active,
.editUser_confirmBtn__j\\+4hp:focus {
  background-color: #205440;
}

.editUser_confirmBtn__j\\+4hp svg {
  top: 0;
}

.editUser_back_dlt__c5lEJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.editUser_delPopContainer__L9Fi- .editUser_modal-body__oo8y2 {
  padding: 25px;
  text-align: center;
}

.editUser_delPopContainer__L9Fi- .editUser_delet_icon__yZfLN {
  margin-bottom: 11px;
}

.editUser_delPopContainer__L9Fi- p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.editUser_arrowback__8QUpw svg {
  fill: #000;
}

.editUser_bodythemedark__gJc0k .editUser_arrowback__8QUpw {
  background-color: #0a2574;
  color: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_arrowback__8QUpw svg {
  fill: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_drpdwn_btn__cYNFI {
  background-color: #132337;
}

.editUser_bodythemedark__gJc0k .editUser_empname__toNaP {
  color: #60677e !important;
}

.editUser_bodythemedark__gJc0k .editUser_navitemli__6fUZp a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingsgeneral__nYDeF,
.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingslinks__b\\+cBE:hover {
  background-color: #0a2574;
  color: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingslinks__b\\+cBE {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .editUser_tableheadlight__t32QY th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .editUser_dashboard__yUISc {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #editUser_dashboardcont2__yX3nJ {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .editUser_sectionright__4UfRu {
    float: unset !important;
  }
  .editUser_dashboard__yUISc {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .editUser_cont2__WDGNX {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .editUser_bodythemelight__KB6by, .editUser_bodythemedark__gJc0k {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .editUser_exer_modal_contain__07NG8 .editUser_modal-dialog__zyLr5 {
    max-width: 1055px;
  }
  .editUser_delPopContainer__L9Fi- .editUser_modal-dialog__zyLr5 {
    max-width: 350px;
  }
}
#editUser_addform__ovjfH {
  width: 100%;
  border-radius: 5px;
  margin-top: 20px;
}
#editUser_addform__ovjfH #editUser_addheading__9mcyJ {
  font-size: 18px;
  margin-bottom: 20px;
}
#editUser_addform__ovjfH .editUser_inputbox1__XD-nG {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
#editUser_addform__ovjfH .editUser_dateinputbox__jSv61 {
  background-color: #F5F6FA;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#editUser_addform__ovjfH .editUser_dateinputbox1__geCZT {
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi {
  background-color: #205440;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #205440;
  cursor: pointer;
  border-radius: 3px;
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw:hover {
  background-color: #205440;
  color: #fff;
}
#editUser_addform__ovjfH ::placeholder {
  font-size: 14px;
  color: #60677e;
}

@media only screen and (max-width: 600px) {
  #editUser_dashboardcont2__yX3nJ {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/editUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAjpBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAmpBJ;AAjpBI;EACI,eAAA;EACA,mBAAA;AAmpBR;AAhpBI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBD6BS;EC3BT,cDgCS;ACinBjB;AA9oBI;EACI,yBDRC;ECSD,kBAAA;EACA,WAAA;EACA,cDuBM;ECtBN,eAAA;AAgpBR;AA9oBI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDaS;ECZT,cDiBS;AC+nBjB;AA7oBI;EACI,yBDuBW;ECtBX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA+oBR;AA7oBQ;EACI,2CDeS;ACgoBrB;AA3oBI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA6oBR;AA3oBU;EACE,yBAAA;EACA,WAAA;AA6oBZ;AAzoBI;EACI,eAAA;EACA,cDhBS;AC2pBjB;;AApoBE;EACE;IACI,wBDEI;ICDJ,UDEG;ICDH,kBAAA;IACA,aDNW;EC6oBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 20px;\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n         \n        color: $lightthemetext;\n         \n    }\n    .dateinputbox{\n        background-color: $mainBg; \n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext; \n    }\n    \n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #205440;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #205440;\n            color: #fff;\n          }\n      }\n\n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n\n  }\n  \n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `editUser_dashboard__yUISc`,
	"dashboardContain": `editUser_dashboardContain__GtVNk`,
	"bodythemedark": `editUser_bodythemedark__gJc0k`,
	"cont2": `editUser_cont2__WDGNX`,
	"top_header": `editUser_top_header__7A80O`,
	"top_header_inner": `editUser_top_header_inner__2GMP0`,
	"subLink": `editUser_subLink__20r54`,
	"footer": `editUser_footer__arSK6`,
	"bodythemelight": `editUser_bodythemelight__KB6by`,
	"headerthemelight": `editUser_headerthemelight__RcR6X`,
	"headerthemedark": `editUser_headerthemedark__1XW9I`,
	"menuthemelight": `editUser_menuthemelight__93STk`,
	"menuthemedark": `editUser_menuthemedark__yR0K2`,
	"menulinklight": `editUser_menulinklight__T1Ugp`,
	"menulinkdarkSelected": `editUser_menulinkdarkSelected__bZWxL`,
	"menulinklightSelected": `editUser_menulinklightSelected__LxANp`,
	"menulinkdark": `editUser_menulinkdark__4Mzbh`,
	"headinglight": `editUser_headinglight__iYkug`,
	"headingdark": `editUser_headingdark__CC5Nk`,
	"searchboxlight": `editUser_searchboxlight__JtJHv`,
	"searchboxdark": `editUser_searchboxdark__c8WH1`,
	"tableheadlight": `editUser_tableheadlight__t32QY`,
	"tableheaddark": `editUser_tableheaddark__IU1BY`,
	"table": `editUser_table__UBG50`,
	"table-borderless": `editUser_table-borderless__vgOBj`,
	"left-section": `editUser_left-section__5Ygpr`,
	"tablebodylight": `editUser_tablebodylight__xGR7k`,
	"tablebodydark": `editUser_tablebodydark__ANb75`,
	"paginationlight": `editUser_paginationlight__UynJG`,
	"paginationdark": `editUser_paginationdark__EfSxZ`,
	"formthemelight": `editUser_formthemelight__+6R3K`,
	"formthemedark": `editUser_formthemedark__91io7`,
	"viewformlight": `editUser_viewformlight__y32+k`,
	"permissionboxlight": `editUser_permissionboxlight__uvNqc`,
	"permissionboxdark": `editUser_permissionboxdark__bgl1b`,
	"errormsgclr": `editUser_errormsgclr__vFQxR`,
	"graphclrlight": `editUser_graphclrlight__0tGaV`,
	"graphclrdark": `editUser_graphclrdark__Oe4fN`,
	"card1bglight": `editUser_card1bglight__kUxQl`,
	"card1bgdark": `editUser_card1bgdark__tfYHD`,
	"card2bglight": `editUser_card2bglight__ZXiVd`,
	"card2bgdark": `editUser_card2bgdark__O1gIJ`,
	"card3bglight": `editUser_card3bglight__xkw1U`,
	"card3bgdark": `editUser_card3bgdark__FCvDO`,
	"card4bglight": `editUser_card4bglight__pic05`,
	"card4bgdark": `editUser_card4bgdark__oir3Z`,
	"actionbtnlight": `editUser_actionbtnlight__3hMAT`,
	"actionbtndark": `editUser_actionbtndark__c1n4B`,
	"profiledropdownlight": `editUser_profiledropdownlight__zqmBO`,
	"profiledropdowndark": `editUser_profiledropdowndark__WK9BI`,
	"settingsection": `editUser_settingsection__qkXU0`,
	"addform": `editUser_addform__ovjfH`,
	"savebtn": `editUser_savebtn__RGuGY`,
	"profile_conatiner": `editUser_profile_conatiner__4m7UK`,
	"ag-theme-alpine": `editUser_ag-theme-alpine__hlul9`,
	"ag-row": `editUser_ag-row__uJXdt`,
	"formbtn": `editUser_formbtn__xQSoi`,
	"resetbtn": `editUser_resetbtn__-wDgG`,
	"addBtn": `editUser_addBtn__UcTNJ`,
	"cust_addBtn": `editUser_cust_addBtn__ZO2er`,
	"deleteBtn": `editUser_deleteBtn__BmqwH`,
	"confirmBtn": `editUser_confirmBtn__j+4hp`,
	"back_dlt": `editUser_back_dlt__c5lEJ`,
	"delPopContainer": `editUser_delPopContainer__L9Fi-`,
	"modal-body": `editUser_modal-body__oo8y2`,
	"delet_icon": `editUser_delet_icon__yZfLN`,
	"arrowback": `editUser_arrowback__8QUpw`,
	"drpdwn_btn": `editUser_drpdwn_btn__cYNFI`,
	"empname": `editUser_empname__toNaP`,
	"navitemli": `editUser_navitemli__6fUZp`,
	"tabnavli": `editUser_tabnavli__aOx2v`,
	"settingsgeneral": `editUser_settingsgeneral__nYDeF`,
	"settingslinks": `editUser_settingslinks__b+cBE`,
	"dashboardcont2": `editUser_dashboardcont2__yX3nJ`,
	"sectionright": `editUser_sectionright__4UfRu`,
	"exer_modal_contain": `editUser_exer_modal_contain__07NG8`,
	"modal-dialog": `editUser_modal-dialog__zyLr5`,
	"addheading": `editUser_addheading__9mcyJ`,
	"inputbox1": `editUser_inputbox1__XD-nG`,
	"dateinputbox": `editUser_dateinputbox__jSv61`,
	"dateinputbox1": `editUser_dateinputbox1__geCZT`
};
export default ___CSS_LOADER_EXPORT___;
